/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function () {
  __assign =
    Object.assign ||
    function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
          if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
  return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P
      ? value
      : new P(function (resolve) {
          resolve(value);
        });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator['throw'](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done
        ? resolve(result.value)
        : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: [],
    },
    f,
    y,
    t,
    g;
  return (
    (g = { next: verb(0), throw: verb(1), return: verb(2) }),
    typeof Symbol === 'function' &&
      (g[Symbol.iterator] = function () {
        return this;
      }),
    g
  );
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError('Generator is already executing.');
    while (_)
      try {
        if (
          ((f = 1),
          y &&
            (t =
              op[0] & 2
                ? y['return']
                : op[0]
                ? y['throw'] || ((t = y['return']) && t.call(y), 0)
                : y.next) &&
            !(t = t.call(y, op[1])).done)
        )
          return t;
        if (((y = 0), t)) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (
              !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
              (op[0] === 6 || op[0] === 2)
            ) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5) throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}

function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++)
    s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
      r[k] = a[j];
  return r;
}

var isAndroid = function isAndroid() {
  var ua = navigator.userAgent;

  if (ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1) {
    return true;
  }

  return false;
};
var versionToNumber = function versionToNumber(versionStr) {
  if (typeof versionStr !== 'string') {
    return 0;
  }

  var attr = versionStr.split('.');
  var len = attr.length;

  while (len < 3) {
    attr.push('0');
    len += 1;
  }

  var resNumber = attr.reverse().reduce(function (total, val, index) {
    var valNumber = parseInt(val || '0', 10) * Math.pow(10, index);
    return total + valNumber;
  }, 0);
  return resNumber;
};
/**
 * 如果 v1 >= v2 返回 true， 否则返回 false
 * @param v1 版本号1
 * @param v2 版本号2
 */

var compareVersion = function compareVersion(v1, v2) {
  var v1Number = versionToNumber(v1 || '');
  var v2Number = versionToNumber(v2 || '');

  if (v1Number >= v2Number) {
    return true;
  }

  return false;
};

var REGISTER_LISTENER_EVT = {}; // ios scheme

var BridgeScheme = 'https://__bridge_loaded__';

function uuid() {
  return Date.now() + '_' + Math.random().toString(32).slice(2, 10);
} // 宿主 webview sdk 版本最低支持版本

var MiniWKSdkV = '1.1.0';
var Version = '0.0.19';
var BuildTime = '1695004120116';
var setBridgeInstance = function setBridgeInstance(jojoBridgeInstance) {
  window.jojoBridgeInstance = jojoBridgeInstance;
};

var JsBridge =
  /** @class */
  (function () {
    function JsBridge(options) {
      this.version = Version;
      this.buildTime = BuildTime; // app 版本

      this.appVersion = ''; // 宿主 webview sdk 版本

      this.wkSdkVersion = ''; // 宿主 webview sdk 版本最低支持版本

      this.miniWKSdkV = MiniWKSdkV;
      this.defaultOptions = {
        debug: false,
        env: 'pro',
        errorHandle: function errorHandle() {},
        timeout: 0,
      };
      this.options = this.defaultOptions;
      this.debugOptions = {
        prefix: 'bridge',
      };
      this.healthCheckTime = 0;
      this.isReady = false; // js 调用 native 方法队列，在js桥未准备完成之前的调用先存储起来

      this.callQueue = [];
      this.notMiniprogram = false; // 小程序环境

      if (JsBridge.HANDLE) {
        return JsBridge.HANDLE;
      } // TODO: 临时判断初始化两次

      if (
        window === null || window === void 0
          ? void 0
          : window.jojoBridgeInstance
      ) {
        return window.jojoBridgeInstance;
      }

      setBridgeInstance(this); // eslint-disable-next-line no-param-reassign

      options = options || {};
      JsBridge.HANDLE = this;
      this.options = __assign(__assign({}, this.defaultOptions), options);
      this.notMiniprogram = window.__wxjs_environment !== 'miniprogram'; // 获取环境版本信息

      this.getVersions();
      this.initBridge(); // 桥健康检查

      this.healthCheck();
    }

    JsBridge.getInstance = function () {
      return this.HANDLE;
    };

    JsBridge.prototype.log = function () {
      var rest = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        rest[_i] = arguments[_i];
      }

      var env = this.options.env;
      var prefix = this.debugOptions.prefix;

      var args = __spreadArrays(
        [
          '%c[' + env + '] ' + prefix,
          'color: white;background: #ff7c7c;border-radius: 2px;',
        ],
        rest
      );

      var isDebug = this.options.debug;

      if (isDebug) {
        // eslint-disable-next-line no-console
        console.log.apply(console, args);
      }
    };
    /**
     * 统一 ios 、 android 桥注册事件
     */

    JsBridge.prototype.initBridge = function () {
      var _this = this; // 桥已经被注册过，直接使用，ios 、android 桥都是使用的这个全局变量

      if (window.WebViewJavascriptBridge) {
        this.log('直接准备ok');
        this.bridgeReady(window.WebViewJavascriptBridge);
        return;
      } // 注册安卓桥通知事件，android 桥初始化成功后会执行这个回调,调用 bridgeReady 方法
      // android 桥的BridgeScheme 被 native sdk 直接注入了一段js

      document.addEventListener(
        'WebViewJavascriptBridgeReady',
        function (e) {
          _this.log('android 异步 准备ok');

          _this.bridgeReady(e.bridge || window.WebViewJavascriptBridge);
        },
        false
      );
      var bridgeReady = this.bridgeReady.bind(this); // 注册ios准备完成回调，ios 桥初始化成功后会从 WVJBCallbacks 中获取回调函数执行，从而执行 bridgeReady 方法

      if (window.WVJBCallbacks) {
        window.WVJBCallbacks.push(bridgeReady);
        return;
      }

      window.WVJBCallbacks = [bridgeReady];

      if (this.notMiniprogram) {
        var WVJBIframe_1 = document.createElement('iframe');
        WVJBIframe_1.style.display = 'none';
        WVJBIframe_1.src = BridgeScheme;
        document.documentElement.appendChild(WVJBIframe_1);
        setTimeout(function () {
          document.documentElement.removeChild(WVJBIframe_1);
        }, 100);
      }
    };

    JsBridge.prototype.bridgeReady = function (bridge) {
      var _this = this; // 已经准备好了，直接返回

      this.log('bridge ready ok');

      if (this.isReady) {
        return;
      }

      this.coreJs = bridge || window.WebViewJavascriptBridge;

      if (bridge.init) {
        // android 特有的init 方法, 需要额外触发一次才能正常通信
        // 调用一次init通知 android native js 准备ok
        bridge.init(function (msg) {
          _this.log(msg);
        });
      }

      this.isReady = true;
      this.registerNativeListener(); // 执行调用时被存储起来的函数队列

      while (this.callQueue.length) {
        var func = this.callQueue.pop();
        func();
      }
    };
    /**
     * 因为bridge建立好通信的过程是一个异步过程，
     * 使用ready函数能保证 cb 是在 bridge 通新建立成功后出发
     * 保证功能正常
     * @param cb 当 bridge 准备好之后出发的函数
     */

    JsBridge.prototype.ready = function (cb) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (_this.isReady) {
          resolve(cb(_this));
        } else {
          // 10 秒后 还没有执行 ready ，抛出异常
          var timer_1 = setTimeout(function () {
            reject(new Error('[ready]native not response'));
          }, 10 * 1000);

          _this.callQueue.push(function () {
            if (timer_1) {
              clearTimeout(timer_1);
            }

            resolve(cb(_this));
          });
        }
      });
    };
    /**
     * 调用native提供的方法
     * @param method native 提供的方法名
     * @param data 需要传递给native的参数
     * @param callback native响应后的处理函数
     */
    // eslint-disable-next-line no-underscore-dangle

    JsBridge.prototype._call = function (method, data, callback) {
      var _this = this;

      var innerCb = callback;
      var innerData = __assign({}, data) || {};

      if (data && typeof data === 'function') {
        innerCb = data;
        innerData = {};
      } // 移除额外的data，避免客户端接受多余数据

      delete innerData.$timeout; // end

      var requestData = {
        data: {
          method: method,
          eventId: uuid(),
          parameters: innerData,
          ext: {},
        },
      };
      var version = this.version;
      return new Promise(function (resolve, reject) {
        var _a = _this,
          coreJs = _a.coreJs,
          options = _a.options;
        var timer = null; // timeout 秒后 native 无响应则抛出错误

        var msg =
          '[jsCallClient]-' +
          version +
          '-' +
          _this.wkSdkVersion +
          ': ' +
          method +
          ' not response';
        var optTimeout =
          data === null || data === void 0 ? void 0 : data.$timeout;
        var tempTimeout =
          optTimeout !== undefined ? optTimeout : options.timeout; // 如果响应超时时间大于 0, 才开启响应检测

        if (tempTimeout !== undefined && tempTimeout > 0) {
          timer = window.setTimeout(function () {
            if (innerCb && typeof innerCb === 'function') {
              innerCb({
                data: null,
                msg: msg,
                status: 400,
              });
            }

            var errorHandle = _this.options.errorHandle;

            if (errorHandle) {
              errorHandle(msg);
            }

            _this.log(msg);

            reject(new Error(msg));
          }, tempTimeout);
        }

        _this.log(
          'web call native methods: ' + method,
          'full msg',
          requestData
        );

        coreJs.callHandler('jsCallClient', requestData, function (res) {
          if (timer) {
            clearTimeout(timer);
            timer = null;
          }

          _this.log('native response msg', res);

          if (typeof res === 'string') {
            // android 特有的格式
            try {
              // eslint-disable-next-line no-param-reassign
              res = JSON.parse(res);
            } catch (e) {
              // eslint-disable-next-line no-param-reassign
              res = {
                data: res,
                msg: 'error-500',
                status: 500,
              };
            }
          }

          var newRes = {
            data: res.data,
            msg: res.msg,
            status: res.status,
          };

          if (innerCb && typeof innerCb === 'function') {
            innerCb(newRes);
          }

          resolve(newRes);
        });
      });
    };

    JsBridge.prototype.call = function (method, data, callback) {
      var _this = this;

      return this.ready(function () {
        return __awaiter(_this, void 0, void 0, function () {
          var resTemp;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [
                  4,
                  /*yield*/
                  this._call(method, data, callback),
                ];

              case 1:
                resTemp = _a.sent();
                return [
                  2,
                  /*return*/
                  resTemp,
                ];
            }
          });
        });
      });
    };
    /**
     * 用于注册native 调用的事件处理函数（方法），允许对一个事件（方法）注册多个处理函数，
     * 如果只有一个处理函数，则native接收到的返回值就是这个处理函数的返回值
     * 如果有多个处理函数，则会把所有处理函数的返回值组装为一个数组，放回给native
     * @param evtName 事件名（方法名），由 native 发起
     * @param callback 对应的处理函数，callback 的返回值会直接返回给native
     */

    JsBridge.prototype.on = function (evtName, callback) {
      var _this = this; // 回调存储在全局变量中
      // 监听事件已经注册过了，直接加入监听队列

      if (REGISTER_LISTENER_EVT[evtName]) {
        this.log(
          'warning: "' +
            evtName +
            '" has multiple handle function, ensure this is correct operation'
        );
        REGISTER_LISTENER_EVT[evtName].push(callback);
      } else {
        // 创建对应事件处理函数的的监听队列
        REGISTER_LISTENER_EVT[evtName] = [callback]; // 向 native 注册监听事件
      }

      return function () {
        _this.off(evtName, callback);
      };
    };
    /**
     * 移除 on 方法的监听处理函数
     * @param evtName on 方法监听的事件名（方法名）
     * @param func on 方法对应的处理函数
     */

    JsBridge.prototype.off = function (evtName, func) {
      var evtArry = REGISTER_LISTENER_EVT[evtName];

      if (evtArry === null || evtArry === void 0 ? void 0 : evtArry.length) {
        var findIndex = evtArry.findIndex(function (item) {
          return item === func;
        });

        if (findIndex > -1) {
          REGISTER_LISTENER_EVT[evtName].splice(findIndex, 1);
        }
      }
    };
    /**
     * 注册用于响应 native 主动调用 js 方法的统一入口方法
     * 所有的业务实现都是通过 clientCallJs 方法中转实现
     */

    JsBridge.prototype.registerNativeListener = function () {
      var _this = this;

      var bridge = this.coreJs;
      bridge.registerHandler('clientCallJs', function (msg, nativeCallback) {
        if (typeof msg === 'string') {
          // eslint-disable-next-line no-param-reassign
          msg = JSON.parse(msg);
        }

        var _a = msg.data || {},
          method = _a.method,
          parameters = _a.parameters;

        _this.log('监听 native(registerHandler) 响应:', method, msg);

        var funcArray = REGISTER_LISTENER_EVT[method] || [];
        var resList = [];

        if (!funcArray.length) {
          var resSsg =
            'waring: web page not has "' +
            method +
            '" handle function, web page should use "on" function to process it';

          _this.log(resSsg);

          nativeCallback({
            originalData: msg.data,
            // 如果数组元素只有一个则，直接返回数据本身，否则返回一个数据结果数组
            data: {},
            status: 404,
            msg: resSsg,
          });
          return;
        }

        for (var i = 0; i < funcArray.length; i += 1) {
          var cb = funcArray[i];
          var res = cb(parameters);
          resList.push(res);
        }

        var response = {
          originalData: msg.data,
          // 如果数组元素只有一个则，直接返回数据本身，否则返回一个数据结果数组
          data: resList.length === 1 ? resList[0] : resList,
          status: 200,
          msg: '成功',
        }; // 响应native数据

        nativeCallback(response);
      });
    };
    /**
     * 获取app的基本信息
     */

    JsBridge.prototype.appInfo = function (cb) {
      return this.call('appInfo', {}, cb);
    };
    /**
     * 获取设备信息
     * @param data any
     * @param cb 响应回调处理函数
     */

    JsBridge.prototype.deviceInfo = function (cb) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        // 兼容 ios 实现字段为 os
        _this
          .call('deviceInfo', {}, function (res) {
            if (res && res.data) {
              res.data.platform = res.data.platform || res.data.os;
            }

            if (cb && typeof cb === 'function') {
              cb(res);
            }

            resolve(res);
          })
          ['catch'](reject);
      });
    };
    /**
     * 打开手机系统浏览器
     * @param data
     * @param cb
     */

    JsBridge.prototype.openBrowser = function (data, cb) {
      return this.call('openBrowser', data, cb);
    };
    /**
     * 是否安装微信
     * @param cb
     */

    JsBridge.prototype.isWechatInstalled = function (cb) {
      var _this = this; // 兼容 android 在 1.1.2 以下都有问题

      return new Promise(function (resolve, reject) {
        _this
          .call('isWechatInstalled', {}, function (res) {
            if (res) {
              res.data = res.data || {};
              res.data.isInstalled = res.data.isInstalled || false;
            }

            if (cb && typeof cb === 'function') {
              cb(res);
            }

            resolve(res);
          })
          ['catch'](reject);
      });
    };
    /**
     * 判断某个app是否安装，需要提供app的包名
     * ios 需要传入app的scheme
     * android 需要传入app的包名
     * 如果想要跨平台查询，则两个数据都需要传入
     * @param data
     * @param cb
     */

    JsBridge.prototype.isAppInstalled = function (data, cb) {
      var newData = data;
      var wkSdkVersion = this.wkSdkVersion; // android 1.1.2 以下实现有有问题

      if (isAndroid()) {
        // 是否大于等于 1.1.2
        if (compareVersion(wkSdkVersion, '1.1.2')) {
          newData.packageName = newData.packageName || '';
          newData.urlScheme = newData.urlScheme || '';
        } else {
          // android 1.1.2 以下不能传入 urlScheme, 传入就会报错
          delete newData.urlScheme;
        }
      } else {
        newData.urlScheme = newData.urlScheme || '';
      }

      return this.call('isAppInstalled', newData, cb);
    };
    /**
     * 打开
     * @param data
     * @param data.packageName android 用, App 包名
     * @param data.page android 用, 用于指定打开 App 页面路径, 可空
     * @param data.urlScheme ios 用, app 的 scheme
     * @param cb
     */

    JsBridge.prototype.openApp = function (data, cb) {
      // 兼容android 必须要传入page参数问题
      // eslint-disable-next-line no-param-reassign
      data.page = data.page || '';
      return this.call('openApp', data, cb);
    };
    /**
     * 打开微信， open 的封装方法
     * @param cb 回调
     */

    JsBridge.prototype.openWeChat = function (cb) {
      return this.openApp(
        {
          urlScheme: 'weixin://',
          packageName: 'com.tencent.mm',
          page: '',
        },
        cb
      );
    };
    /**
     * 检测 app webview 是否支持 某个 api 方法
     * @param data
     * @param cb
     */

    JsBridge.prototype.hasApi = function (data, cb) {
      return this.call('hasApi', data, cb);
    };
    /**
     * canUse 的别名方法,可以再实例上直接使用
     */

    JsBridge.prototype.canUseBridge = function () {
      return JsBridge.canUse();
    };
    /**
     * 判断宿主app环境是否支持该桥的通信,
     * 因为存在新桥老桥更新迭代的问题，
     * 所以可以通过该方法做一下兼容处理给用户一个友好的提示
     */

    JsBridge.canUse = function () {
      // ios 8 上，同一个app的所有 webview UA是公用的，所以在ios8上使用这个变量注入来区分webview是否支持bridge
      var ua = window.__jojoWebViewUA || navigator.userAgent;
      var res = false;

      if (ua.indexOf('JoJoWebViewSymbol') > -1) {
        res = true; // 兼容 阅读思维有问题的app版本

        var appVersion = JsBridge.getVersion().appVersion;
        var matchVersion = ua.match(/android\s([0-9\\.]*)/i);
        var androidVersion = matchVersion ? matchVersion[1] : '0.0.0';
        var bigVersion = androidVersion.split('.')[0] || '0';
        var bigVersionNum = parseInt(bigVersion, 10);

        if (ua.indexOf('JoJoAppFrom/read') > -1) {
          // 阅读有问题的app，阅读低于 1.3.10 的版本有问题
          if (!compareVersion(appVersion, '1.3.10')) {
            // 临时修复 思维新桥在 android 4、5、6 不生效问题, 只在7.0.0以及以上，这段代码只是临时 hack，后续版本会移除掉
            if (isAndroid() && bigVersionNum < 7) {
              res = false;
            }
          }
        } // 思维 app

        if (ua.indexOf('JoJoAppFrom/math') > -1) {
          // 阅读有问题的app，阅读低于 1.3.10 的版本有问题
          if (!compareVersion(appVersion, '1.1.7')) {
            // 临时修复 思维新桥在 android 4、5、6 不生效问题, 只在7.0.0以及以上，这段代码只是临时 hack，后续版本会移除掉
            if (isAndroid() && bigVersionNum < 7) {
              res = false;
            }
          }
        }
      }

      return res;
    };

    JsBridge.getVersion = function () {
      var ua = window.__jojoWebViewUA || navigator.userAgent; // const ua = 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/86.0.4240.111 Safari/537.36 JoJoWebViewSymbol/2.42.0 JoJoWebViewVersion/1.0.0';

      var appVersionRx = new RegExp('JoJoWebViewSymbol/(\\S+)', 'ig');
      var appVersion = '0.0.0';
      var version = (appVersionRx.exec(ua) || {})[1];
      appVersion = version;
      var wkSdkV = '0.0.0';
      var wkSdkVRx = new RegExp('JoJoWebViewVersion/(\\S+)', 'g');
      var version1 = (wkSdkVRx.exec(ua) || {})[1];
      wkSdkV = version1;
      return {
        wkSdkVersion: wkSdkV,
        miniWKSdkVersion: MiniWKSdkV,
        appVersion: appVersion,
        version: Version,
      };
    };
    /**
     * 获取sdk版本信息
     */

    JsBridge.prototype.getVersions = function () {
      var versions = JsBridge.getVersion();
      var appVersion = versions.appVersion,
        wkSdkVersion = versions.wkSdkVersion;
      this.log(
        'sdkV:' +
          this.version +
          ' | appV:' +
          appVersion +
          ' | wkSdkV:' +
          wkSdkVersion +
          ' | miniWKSdkV:' +
          this.miniWKSdkV
      );
      this.wkSdkVersion = wkSdkVersion;
      this.appVersion = appVersion;
      return {
        wkSdkVersion: wkSdkVersion,
        miniWKSdkVersion: this.miniWKSdkV,
        appVersion: versions.appVersion,
        version: this.version,
      };
    }; // js bridge 健康检查

    JsBridge.prototype.healthCheck = function () {
      var _this = this;

      setTimeout(function () {
        var errorHandle = _this.options.errorHandle; // 2 秒之后js bridge 通信还没有建立成功，则尝试重新建立通信

        if (_this.healthCheckTime > 2) {
          if (!(window.WebViewJavascriptBridge || _this.isReady)) {
            errorHandle(
              'js bridge connect failed, try ' +
                _this.healthCheckTime +
                ' times, maybe has some error.'
            );
          } else if (window.WebViewJavascriptBridge && !_this.isReady) {
            _this.bridgeReady(window.WebViewJavascriptBridge);
          }

          return;
        }

        _this.healthCheckTime += 1;

        if (window.WebViewJavascriptBridge) {
          _this.bridgeReady(window.WebViewJavascriptBridge);

          return;
        } // js 桥没有准备好

        if (!_this.isReady && _this.notMiniprogram) {
          // 重新出发ios native 建立桥通信
          var WVJBIframe_2 = document.createElement('iframe');
          WVJBIframe_2.style.display = 'none';
          WVJBIframe_2.src = BridgeScheme;
          document.documentElement.appendChild(WVJBIframe_2);
          setTimeout(function () {
            document.documentElement.removeChild(WVJBIframe_2);
          }, 100);

          _this.healthCheck();
        }
      }, 2 * 1000);
    };

    return JsBridge;
  })();

export { JsBridge as default, setBridgeInstance };
